import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BuildInfoBadge from '@repo/common-frontend/src/components/BuildInfoBadge';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <React.Fragment>
      <footer className="footer mt-3">
        <Container fluid>
          <Row>
            <Col sm={6}>
              <div className="d-flex align-items-center justify-content-between gap-2">
                <span>{year} © Phenom Poker.</span>
                <BuildInfoBadge
                  placement="inline"
                  className="rounded-0 border-0 bg-transparent px-0 py-0 italic text-current opacity-75 shadow-none backdrop-blur-none"
                />
              </div>
            </Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">Phenom Poker</div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
